import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {HorizontalLine} from "./HorizontalLine";
import {StepForm} from "../../../models/api/codegen/code";
import {Visible} from "../../../utils/Visible";
import {BetStatusButton} from "../../MyBets/BetStatusButton";


function getColorByStatus(status: StepForm['status']) {
    switch (status) {
        case "WAITING":
            return '#FBD830';
        case "REFUND":
            return '#FFFFFF';
        case "CANCELLED":
            return '#828282';
        case "IN_PLAY":
            return '#15B5FE';
        case "WINNER":
            return '#37E76E';
        case "LOSER":
            return '#FC4748';
        default:
            return '#FBD830';
    }
}


const BadgeWrapper = styled.div<StepFooterProps>`
    color: ${props => getColorByStatus(props.step.status)};
    padding-top: 14px;
    padding-bottom: 4px;
`;
BadgeWrapper.displayName = 'BadgeWrapper';


type StepFooterProps = {
    odds?: number;
    view: View;
    step: StepForm
}

export type View = 'my-bets' | 'steps';

export function StepFooter(props: StepFooterProps) {
    const { t } = useTranslation();
    const {odds, step, view} = props;

    const prefix = (step.type === 'ORDINAR' || view === "my-bets") ? 'coefficient' : 'totalCoefficient';

    return (
        <>
            <HorizontalLine borderColor={'#03A9F4'}/>

            <div className="py-[8px] px-[10px]">
                <h3>
                    {step.type !== "SYSTEM" && (
                        <div className="flex justify-between text-[#ABABAB]">
                            <span>{t('steps.step.' + prefix)}</span>
                            {odds && <span>{odds.toFixed(2)}</span>}
                        </div>
                    )}
                    <HorizontalLine borderColor={'rgba(216,216,216,0.3)'}/>
                    <Visible value={view === "steps"}>
                        <div className="flex justify-between">
                            <span>{t('steps.step.potentialResult')}</span>
                            {step.rate && odds && <span>{(step.rate * odds).toFixed(2)}</span>}
                        </div>
                    </Visible>
                    <Visible value={view === "my-bets"}>
                        <div className="flex justify-between text-[#ABABAB]">
                            <span>{t('myBets.header.rate')}</span>
                            {<span>{step.rate}</span>}
                        </div>
                        <HorizontalLine borderColor={'rgba(216,216,216,0.3)'}/>
                        <div className="flex justify-between text-[#ABABAB]">
                            <span>{t('myBets.header.winResult')}</span>
                            {<span>{step.win === 0 ? '0.00' : step.win}</span>}
                        </div>
                    </Visible>
                    {step.status && <div className="flex justify-end items-center">
                        <Visible value={view === "my-bets"}>
                            <BetStatusButton calculated={step.calculated}
                                             betStatus={step.status}
                                             winning={step.winning}
                                             type={step.type}
                                             isChild={false}
                                             parentStatus={step.status}
                                             steps={step.type === 'EXPRESS' ? step.steps : null}
                            />
                        </Visible>
                        <Visible value={view === "steps"}>
                            <BadgeWrapper {...props}>
                                <h5>
                                    {t('steps.step.status.' + step.status)}
                                </h5>
                            </BadgeWrapper>
                        </Visible>
                    </div>}
                </h3>
            </div>
        </>
    );

}
